import { Typography } from "@cpj-ai/panel-npm-package";
import { JobPositionInterviewSlotType } from "@graphql/generated";
import { Button } from "@heroui/react";
import dayjs from "dayjs";
import React from "react";

interface TimeSlotGridProps {
  slots: JobPositionInterviewSlotType[];
  selectedTimeSlot: JobPositionInterviewSlotType | null;
  onSelectTimeSlot: (time: JobPositionInterviewSlotType) => void;
}

const TimeSlotGrid: React.FC<TimeSlotGridProps> = ({ slots, selectedTimeSlot, onSelectTimeSlot }) => {
  return (
    <div className="mt-2">
      <Typography className="text-default-700 mb-4 font-medium">
        Please select a start time for your interview :
      </Typography>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
        {slots.map((slot) => (
          <Button
            key={slot.id}
            variant={selectedTimeSlot?.datetime[0] === slot.datetime[0] ? "solid" : "bordered"}
            color={selectedTimeSlot?.datetime[0] === slot.datetime[0] ? "primary" : "default"}
            className={`h-12 ${!slot.isAvailable ? "opacity-50" : ""}`}
            isDisabled={!slot.isAvailable}
            onPress={() => onSelectTimeSlot(slot)}
          >
            {dayjs(slot.datetime[0]).format("HH:mm")} - {dayjs(slot.datetime[1]).format("HH:mm")}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default TimeSlotGrid;
